"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCard = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("./index");
const product_card_styles_1 = require("./product-card.styles");
const ProductCard = ({ id, images, title, proprietaryId, isChecked, onCheckProduct, }) => {
    var _a;
    const sourceUrl = (_a = images[0]) === null || _a === void 0 ? void 0 : _a.sourceUrl;
    return (react_1.default.createElement(product_card_styles_1.StyledProductCard, { isChecked: isChecked, onClick: () => onCheckProduct(id) }, react_1.default.createElement(index_1.CheckIcon, null), react_1.default.createElement(product_card_styles_1.StyledImage, { image: sourceUrl }), react_1.default.createElement(product_card_styles_1.StyledBlock, null, react_1.default.createElement(product_card_styles_1.StyledTitle, null, title), react_1.default.createElement(product_card_styles_1.StyledSkiId, null, proprietaryId))));
};
exports.ProductCard = ProductCard;
exports.default = exports.ProductCard;
